import axios from '@axios'

const route = 'register/room_category'
export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getAll(context, { itemsPerPage, page, search }) {
      return axios.get(`${route}?page=${page}&items_per_page=${itemsPerPage}&search=${search}`)
    },
    store(context, roomCategory) {
      return axios.post(route, roomCategory)
    },
    update(context, roomCategory) {
      return axios.put(`${route}/${roomCategory.id}`, roomCategory)
    },
    delete(context, roomCategory) {
      return axios.delete(`${route}/${roomCategory.id}`)
    },
  },
}
